import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Speaker = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M10 6.25a.75.75 0 0 0 0 1.5zm4 1.5a.75.75 0 0 0 0-1.5zm-7-4h10v-1.5H7zM18.25 5v14h1.5V5zM17 20.25H7v1.5h10zM5.75 19V5h-1.5v14zM7 20.25c-.69 0-1.25-.56-1.25-1.25h-1.5A2.75 2.75 0 0 0 7 21.75zM18.25 19c0 .69-.56 1.25-1.25 1.25v1.5A2.75 2.75 0 0 0 19.75 19zM17 3.75c.69 0 1.25.56 1.25 1.25h1.5A2.75 2.75 0 0 0 17 2.25zM7 2.25A2.75 2.75 0 0 0 4.25 5h1.5c0-.69.56-1.25 1.25-1.25zM14.25 14A2.25 2.25 0 0 1 12 16.25v1.5A3.75 3.75 0 0 0 15.75 14zM12 16.25A2.25 2.25 0 0 1 9.75 14h-1.5A3.75 3.75 0 0 0 12 17.75zM9.75 14A2.25 2.25 0 0 1 12 11.75v-1.5A3.75 3.75 0 0 0 8.25 14zM12 11.75A2.25 2.25 0 0 1 14.25 14h1.5A3.75 3.75 0 0 0 12 10.25zm-2-4h4v-1.5h-4z'
        fill='currentColor'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.25 5A2.75 2.75 0 0 1 7 2.25h10A2.75 2.75 0 0 1 19.75 5v14A2.75 2.75 0 0 1 17 21.75H7A2.75 2.75 0 0 1 4.25 19zm5 2a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4A.75.75 0 0 1 9.25 7m-1 7a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0M12 11.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5'
        fill='currentColor'
      />
    )}
  </IconBase>
);
